export type ServiceCode = string

/** Commission rate applied to the gross order value. */
export const ORDER_COMMISSION_RATE = 0.1

export function calculateOrderCommission(grossAmount: number): number {
  return grossAmount * ORDER_COMMISSION_RATE
}

export type OrderStatus =
  | 'SUBMITTED'
  | 'APPROVED'
  | 'REJECTED'
  | 'CORRECTED'
  | 'DELETED'
  | 'COMPLETED'

export interface Order {
  id: number
  userId: string
  bankId: number
  status: OrderStatus
  startTime: string // ISO date
  endTime: string // ISO date
  buckets: OrderBucket[]
  createdAt: string
  updatedAt: string
  attachmentsCount?: number
  userName?: string
  username?: string
  attachmentCount: number
  bankName?: string
  customerId?: number
  grossAmount?: number
}

export interface OrderAttachment {
  id: number
  entityId: number
  entityType: 'ORDER'
  filename: string
  contentType: string
  fileSize: number
  uploadedBy: string
  uploadedAt: string
}

export type OrderAttachmentFileDetails = {
  id: number
  name: string
  url?: string
}

export interface OrderBucket {
  serviceType: ServiceCode
  plannedHours: number
  serviceName?: string
}

export interface OrderHistory {
  id: number
  orderId: number
  fromStatus: Omit<OrderStatus, 'DELETED' | 'COMPLETED'>
  toStatus: Omit<OrderStatus, 'DELETED' | 'COMPLETED'>
  userId: string
  note?: string
  payload?: {
    newBuckets?: OrderBucket[]
    oldBuckets?: OrderBucket[]
    // keep it loose; you can extend later
    [key: string]: any
  }
  createdAt: string
}

/**
 * One service of GET /orders/workload, named as the backend sends it (WorkloadBucketDto). All
 * values are hours for the queried window. The backend returns one bucket per service type and
 * fills every value, 0 when nothing applies, so a value is never absent.
 */
export interface WorkloadBucket {
  serviceType: ServiceCode
  /** The SIB's capacity for the window's year. */
  capacityHours: number
  /** capacityHours - approvedOrderHours */
  remainingCapacityHours: number
  /** APPROVED and COMPLETED orders, pro-rated by days to the window */
  approvedOrderHours: number
  /** Activities performed in the window (not invoiced quantities) */
  completedActivityHours: number
  /** approvedOrderHours - completedActivityHours */
  remainingApprovedOrderHours: number
}
